// extracted by mini-css-extract-plugin
export default {"followUsContainer":"I06GC","iconsRow":"UpphA","icon":"sxSdJ","facebookIcon":"cPn2e","linkedInIcon":"yFrHA","instagramIcon":"x4TVQ","twitterIcon":"dscSD","inverted":"j2dof"};